module.exports = __webpack_public_path__ + "img/canon-camera.33a08a65.jpg";